
import { countersignSoa, soaProductLabels, soaSigningState } from '~/util/soa'

export default {
    props: {
        client: {
            type: Object,
            default: null
        },
        days: {
            type: Number,
            default: 60
        },
        title: {
            type: String,
            default: 'Signed Pre-Consult SOA in the past 60 days:'
        },
    },
    data () {
        return {
            soas: [],
            total: 0,
            // id of the SOA currently being deleted, so the row shows a spinner
            // and a second click can't fire the same delete twice.
            deleting: null,
            // id of the SOA being countersigned, likewise
            signing: null,
            form: {
                days: this.days,
                query: this.$route.query.query || '',
                page: parseInt(this.$route.query.page) || 1,
                size: parseInt(this.$route.query.size) || 3
            },
        }
    },
    async fetch () {
        return await this.search()
    },
    computed: {
        // the template compiler (buble) under jest does not parse `?.`
        clientId () {
            return this.client && this.client.id
        },
    },
    watch: {
        'client.id' (v) {
            this.form.page = 1
            this.search()
        },
        days (v) {
            this.form.days = v
            this.search()
        },
        'form.page' (v) {
            this.search()
        },
    },
    methods: {
        hasPdf (soa) {
            return !!(soa && soa.value && soa.value.envelope_item_id)
        },
        awaitingAgent (soa) {
            return soaSigningState(soa).awaitingAgent
        },
        canSign (soa) {
            const state = soaSigningState(soa)
            return state.awaitingAgent || state.failed
        },
        productLabels (soa) {
            return soaProductLabels(soa)
        },
        async sign (soa) {
            if (this.signing) { return }
            this.signing = soa.id
            const resp = await countersignSoa(this, this.clientId, soa)
            this.signing = null
            if (!resp) { return }
            this.$emit('signed', resp)
            return await this.search()
        },
        async confirmDelete (soa) {
            if (this.deleting) { return }
            const ok = await this.$bvModal.msgBoxConfirm(
                `Delete ${soa.key}? This removes the signed document from Documenso as well, and cannot be undone.`,
                { title: 'Delete this signed SOA?', okTitle: 'Delete', okVariant: 'danger', centered: true },
            )
            if (!ok) { return }

            this.deleting = soa.id
            const resp = await this.$try('deleteSignedSoa', this.client?.id, soa.key)
            this.deleting = null
            if (resp && resp.error) { return }

            this.$store.commit('pushAlert', { message: 'SOA deleted.', timeout: 2000, variant: 'success' })
            // The deleted row may have been the one backing soa60days, which
            // gates the SOA block on the client's sign step — clear it so the
            // page doesn't keep claiming they've already signed.
            if (this.$store.getters.soa60days?.key === soa.key) {
                this.$store.commit('soa60days', null)
            }
            this.$emit('deleted', soa)
            return await this.search()
        },
        async search () {
            const { items, total, error, page } = await this.$try('getSignedSoas', this.client?.id, {
                days: this.form.days,
                page: this.form.page,
                size: this.form.size
            })
            if (!error) {
                this.soas = items
                this.total = total || 0
                this.form.page = page
            }
        },
    }
}
